import { render, staticRenderFns } from "./NewCalendar.vue?vue&type=template&id=06bf2a48&scoped=true"
import script from "./NewCalendar.vue?vue&type=script&lang=js"
export * from "./NewCalendar.vue?vue&type=script&lang=js"
import style0 from "./NewCalendar.vue?vue&type=style&index=0&id=06bf2a48&prod&lang=scss"
import style1 from "./NewCalendar.vue?vue&type=style&index=1&id=06bf2a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf2a48",
  null
  
)

export default component.exports